const expanderWrappers = document.querySelectorAll('.mobile-expander-wrapper');
const mobileExpanderButtons = document.querySelectorAll(
  '.mobile-expander-button'
);

export function resetAllMobileExpandedWrappers() {
  expanderWrappers.forEach((el) => (el.dataset.mobileExpanded = false));
}

function handleMobileExpanderButton(event) {
  event.preventDefault();

  const wrapper = event.target.closest('.mobile-expander-wrapper');
  wrapper.dataset.mobileExpanded =
    wrapper.dataset.mobileExpanded === 'true' ? 'false' : 'true';
}

mobileExpanderButtons.forEach((expanderBtn) => {
  expanderBtn.addEventListener('click', handleMobileExpanderButton);
});
